// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../baseQuery';
import { BreadcrumbModel, BreadcrumbRequestModel } from './breadcrumbModels';

export const breadcrumbApi = createApi({
  reducerPath: 'breadcrumbApi',
  baseQuery: baseQuery('breadcrumb'),
  endpoints: (builder) => {
    return {
      getBreadcrumb: builder.query<BreadcrumbModel[], BreadcrumbRequestModel>({
        query: ({ famille_uuid, produit_uuid, article_uuid, reseau_uuid, univers_uuid, lang }) => {
          return {
            url: '',
            method: 'get',
            params: { famille_uuid, produit_uuid, article_uuid, reseau_uuid, univers_uuid, lang },
          };
        },
      }),
    };
  },
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetBreadcrumbQuery, useLazyGetBreadcrumbQuery } = breadcrumbApi;
